import { useEffect } from 'react';

// @ts-expect-error untyped
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ANALYZE_BACKFILLING } from '../../constants/Events';
import Links from '../../constants/Links';
import { trackClickKBLink, trackViewAnalyzeTab } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BackfillingAIProjections = () => {
  useEffect(() => {
    trackViewAnalyzeTab({
      subscreen: ANALYZE_BACKFILLING
    });
  }, []);
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    blockSize: "600px",
    "data-test-id": "analyze-backfilling",
    justifyContent: "space-around",
    children: /*#__PURE__*/_jsxs(View, {
      borderColor: "border-primary-subtle",
      borderStyle: "solid",
      borderWidth: "100",
      children: [/*#__PURE__*/_jsx(Flex, {
        justifyContent: "end",
        paddingBlock: "600",
        paddingInline: "600",
        children: /*#__PURE__*/_jsx(AIBadge, {})
      }), /*#__PURE__*/_jsx(EmptyState, {
        primaryContent: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "analyze.backfilling.message"
          }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
            url: Links.AI_FORECAST_KB,
            onClick: () => trackClickKBLink({
              subscreen: ANALYZE_BACKFILLING
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "analyze.backfilling.learnMore"
            })
          })]
        }),
        secondaryContent: /*#__PURE__*/_jsx(Illustration, {
          name: "automated-testing",
          width: 150
        }),
        secondaryContentWidth: 200,
        titleText: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "analyze.backfilling.title"
          })
        })
      })]
    })
  });
};
export default BackfillingAIProjections;